import React, {useState, useEffect} from 'react';
import Loader from "react-loader-spinner";
import * as typingCenterUserActions from '../../Redux/Actions/typingCenterUser';
import {toastMessage} from '../../utils/toast';
import { getParams } from '../../utils';
import { useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { validationError, clearSession } from '../../utils/initiate';

const UpdateUser = ({ history }) => {

    const [loading, setLoading] = useState(false);
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [mobileNumber, setMobileNumber] = useState();
    const [buttonLoading, setButtonLoading] = useState(false);
    const [extensionNumber, setExtensionNumber] = useState('');
    const [userLimit, setUserLimit] = useState('');
    const [emiratesId, setEmiratesId] = useState('');

    const [departmentsList, setDepartmentsList] = useState([]);
    const [masterProcessList, setMasterProcessList] = useState([]);
    const [departmentID, setDepartmentID] = useState('');
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedMasterProcess, setSelectedMasterProcess] = useState([]);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    let params = getParams(window.location.search);
    let userID = params.userID;

    useEffect(() => {
        setLoading(true);
        typingCenterUserActions.getIndividual(userID).then(res => {
            if(res && res.data){
                let data = res.data;
                setName(data.name);
                setEmail(data.email);
                setMobileNumber(data.mobileNumber);
                setExtensionNumber(data.extensionNumber);
                setEmiratesId(data.emiratesId);
                setUserLimit(data.userLimit);
                handleGetAllServices(data.typingCenterSkills);
            }else{
                toastMessage('error', (res && res.message) || `Unable to get the user info`);
            }
            setLoading(false);
        }).catch(err => {
            (err.response.status === 401) && clearSession(dispatch, history);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userID]);

    const handleGetAllServices = (data) => {
        let skillIds = data.map(({skillId}) => skillId);
        typingCenterUserActions.getAllServices().then(res => {
            if(res && res.data){
                setLoading(false);
                setDepartmentsList(res.data.departments);
                setSelectedMasterProcess(skillIds);
                handleSetDepartmentIDs(res.data.departments, skillIds);
            }else{
                toastMessage('error', 'Unable to load the process');
            }
        }).catch(err => {
            toastMessage('error', `Unable to load the process`);
        });
    };

    const handleSetDepartmentIDs = (departments, skillIds) => {
        let departmentIds = []
        let data = departments.map(({id, masterProcess}) => ({
            id, 'masterProcess': masterProcess.map(({id}) => id)
        }));
        
        for (let i=0; i < data.length; i++) {
            let isDepartment = false;
            if (data[i].masterProcess.length === 1) {
                isDepartment = skillIds.includes(data[i].masterProcess[0]);
            } else {
                let multipleMP = [];
                data[i].masterProcess.forEach(id =>
                    skillIds.includes(id) ? multipleMP.push(id) : ''
                );
                isDepartment = multipleMP.length === data[i].masterProcess.length; 
            }
            if (isDepartment) {
                departmentIds.push(data[i].id)
            }
        }
        setSelectedDepartment(departmentIds);
    };

    const handleList = (key, ID) => {
        let list = [];
        if (key === 'department'){
            list = departmentsList.filter(({id}) => id === ID)[0].masterProcess;
            setMasterProcessList(list);
        }
        // else{
        //     list = masterProcessList.filter(({id}) => id === ID)[0].process;
        //     setProcessList(list);
        // }
    };

    const handleSelectedDepartment = (event) => {
        let list = departmentsList.filter(({id}) => id === parseInt(event.target.value, 10))[0].masterProcess;
        if (event.target.checked){
            setSelectedDepartment([...selectedDepartment, parseInt(event.target.value, 10)]);
            list = list.map(({id}) => id);
            let newList = [...list, ...selectedMasterProcess]
            let rmDuplicates = [...new Set(newList)];
            setSelectedMasterProcess(rmDuplicates);
        }else{
            const newList = selectedDepartment.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
            setSelectedDepartment(newList)
            list.map(({id}) => {
                let Index = selectedMasterProcess.indexOf(id);
                return (Index === -1) ? '' : selectedMasterProcess.splice(Index, 1);
            });
            setSelectedMasterProcess(selectedMasterProcess);
        }
    };
  
    const handleSelectedMasterProcess = (event, deptID) => {
        let mpList = departmentsList.filter(({id}) => id === parseInt(deptID, 10))[0].masterProcess;
        if (event.target.checked){
            let updatedMP = [...selectedMasterProcess, parseInt(event.target.value, 10)];
            let updatedDP = [];
            if (mpList.length === 1) {
                updatedDP = [...selectedDepartment, parseInt(deptID, 10)];
            } else {
                let multipleMP = [];
                mpList.forEach(({id}) =>
                    updatedMP.includes(id) ? multipleMP.push(id) : ''
                );
                updatedDP = (mpList.length === multipleMP.length) ? [...selectedDepartment, parseInt(deptID, 10)] : selectedDepartment;
            }
            setSelectedDepartment(updatedDP);
            setSelectedMasterProcess(updatedMP);
        }else{
            const deptList = selectedDepartment.map(item => (item === deptID) ? false : item).filter(Boolean);
            setSelectedDepartment(deptList)
            const newList = selectedMasterProcess.map(item => (item === parseInt(event.target.value, 10)) ? false : item).filter(Boolean);
            setSelectedMasterProcess(newList);
        }
    };
      
    const isDeptChecked = id => selectedDepartment.find(item => item === parseInt(id, 10));
    const isMPChecked = id => {
        let response = selectedMasterProcess.find(item => item === parseInt(id, 10));
        return (response === undefined) ? false : response;
    };

    const handleUpdateUser = () => {
        let payload = { id: userID, name, email, mobileNumber, extensionNumber, userLimit, emiratesId, skillIds: selectedMasterProcess };
        setButtonLoading(true);
        if((name !== '') && (email !== '') && (userLimit !== '') ){
            typingCenterUserActions.update(payload).then(res => {
                if(res && res.data) {
                    toastMessage('success', `User updated successfully`); 
                    history.push('/users');
                }
                else{
                    toastMessage('error', `User update Failed`);
                }  
            }).catch(err => {
                //toastMessage('error', err.response.data.message);
                (err.response.status === 400) && validationError(err.response);
                (err.response.status === 401) && clearSession(dispatch, history);
            });
            setButtonLoading(false);
        }else{
            setButtonLoading(false);
            toastMessage('error', `Enter the correct User details`);
        }
    };

    return(
        <div className="container-fluid">
            <div className="my-4">
                <span className="card-label font-weight-bolder c-pointer" onClick={() => history.push(`/users`)}>{t("userManagement.updateUser.users")}</span>
                <span className="card-label font-weight-bolder mx-2">/</span>
                <span className="card-label font-weight-bolder text-dark">{name}</span>
            </div>
            <div className="row">
                <div className="col-lg-12 col-xxl-12">
                    <div className="card card-stretch">
                        <div className="card-header border-0 py-2">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label font-weight-bolder text-dark">{t("userManagement.updateUser.title")}</span>
                            </h3>
                        </div>
                        {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center'}} />
                        : <div className="card-body py-0">
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("userManagement.updateUser.name")}</label>
                                <input placeholder={t("userManagement.updateUser.namePlaceholder")} type="text" className="form-control"
                                    name="Name" value={name} onChange={e => setName(e.target.value)} />
                            </div>
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("userManagement.updateUser.email")}</label>
                                <input placeholder={t("userManagement.updateUser.emailPlaceholder")} type="text" className="form-control"
                                    name="Email" value={email} onChange={e => setEmail(e.target.value)} />
                            </div>
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("userManagement.updateUser.mobileNumber")}</label>
                                <input placeholder={t("userManagement.updateUser.mobileNumberPlaceholder")} type="text" className="form-control"
                                    name="Mobile Number" value={mobileNumber} onChange={e => setMobileNumber(e.target.value)} />
                            </div>
                            <div className="form-group fv-plugins-icon-container">
                                <label className="mb-1">{t("userManagement.updateUser.extensionNumber")}</label>
                                <input placeholder={t("userManagement.updateUser.extensionNumberPlaceholder")} type="text" className="form-control"
                                    name="Extension Number" value={extensionNumber} onChange={e => setExtensionNumber(e.target.value)} />
                            </div>
                            <div className="form-group fv-plugins-icon-container">
                                <label  className="mb-1">{t("userManagement.addUser.emiratesId")}</label>
                                <input placeholder={t("userManagement.addUser.emiratesIdPlaceholder")} type="text" className="form-control"
                                name="Extension Number" value={emiratesId} onChange={e => setEmiratesId(e.target.value)} />
                            </div>
                            <div className="form-group fv-plugins-icon-container">
                                    <label  className="mb-1">{t("userManagement.addUser.userLimit")}</label>
                                    <input placeholder={t("userManagement.addUser.userLimitPlaceholder")} type="text" className="form-control"
                                        name="User Limit" value={userLimit} onChange={e => setUserLimit(e.target.value)} />
                                </div>
                            <div className="mb-3">
                                <p className="mb-1">{t("userManagement.addUser.skills")}<span className="text-danger">*</span></p>
                                <label className="form-label mb-2">{t("userManagement.addUser.department")}</label>
                                <div>
                                    {departmentsList.map(({name, id}) => 
                                        <div className='d-flex flex-column' key={id}>
                                            <div key={id} className='d-flex align-items-center mb-2 c-pointer'>
                                                <input type='checkbox' className='me-2' value={id} checked={isDeptChecked(id)} onChange={handleSelectedDepartment} />
                                                <p className="m-0" onClick={() => {handleList('department', id); setDepartmentID(id === departmentID ? '' : id)}}>{name}</p>
                                            </div>
                                            {(departmentID === id) && (masterProcessList.length !== 0) && <div className="mb-3 ms-4">
                                                <label className="form-label mb-1">{t("userManagement.addUser.masterProcess")}</label>
                                                <div>
                                                    {masterProcessList.map(({name, id: mpID}) =>
                                                        <div key={mpID} className='d-flex align-items-center mb-1 c-pointer'>
                                                            <input type='checkbox' className='me-2' name={name} id={name} value={mpID}
                                                                checked={isMPChecked(mpID)} onChange={e => handleSelectedMasterProcess(e, id)} />
                                                            <label className="m-0" htmlFor={name}>{name}</label>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <button disabled={buttonLoading} onClick={handleUpdateUser} type="button" className="d-flex align-items-center btn btn-primary font-weight-bold mb-3">
                                {t("userManagement.updateUser.title")} {buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateUser;